import { defer } from 'react-router-dom'
import { getQueryStringParamsFromStringUrl, logger } from '$utils'
import { isAppStateReady } from 'src/state/store'
import { UnavailabilityStatus } from '$constants'
import { unavailabilityService } from '$services'
import { IUnavailabilityRecord } from '$models'

export default async function loader({ request: { url } }) {
  const queryParams = getQueryStringParamsFromStringUrl(url)

  logger.debug(
    '[loader] About to await AppState being ready in employee Unavailability Status loader'
  )
  await isAppStateReady()
  logger.debug(
    '[loader] AppState should now be ready in employee Unavailability Status loader'
  )

  // Grab url params
  const {
    company: companyName,
    firstname: firstName,
    lastname: lastName,
    recordId,
    status,
  } = queryParams

  // NOTE that it is expected requests to this loader will happen on a page
  // with a one time token. This means you can't make API calls to our normal
  // backend as the user will most likely _not_ be authenticated. Data that
  // needs to be displayed can be included as url query params where appropriate.

  // Immediately process the status update, the response this to single API call
  // is used for the display on the page about to be loaded.
  const updatedUnavailability = unavailabilityService.updateStatus(
    recordId,
    status as unknown as UnavailabilityStatus
  )

  return defer({
    data: Promise.all([updatedUnavailability, companyName, firstName, lastName])
      .then((result) => {
        return result as [IUnavailabilityRecord, string, string, string]
      })
      .catch((error) => {
        logger.error('Employee Unavailability Status Promise.all error', error)
        return [undefined, undefined, undefined, undefined]
      }),
  })
}
